/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { ReactNode } from 'react';

export interface SectionDataProps {
  cols?: string;
  label?: string;
  value?: number | boolean | string;
}

export default function SectionData({ cols, label, value, children }: SectionDataProps & { children?: ReactNode }) {
  if (!cols) {
    cols = '';
  }
  return (
    <div className={'section-data ' + cols}>
      <span className="label">{label}</span>
      <span className="value">{children || String(value)}</span>
    </div>
  );
}
